(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('header-announcement-container');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerheight = this.headerBounds.bottom;
        if(scrollTop > headerheight){
          this.reveal();
        }

      //
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      if (window.innerWidth < 660) {
        // Get references to the div elements
        const sortBySelector = document.querySelector('.stickyheader--active .facets-container');
        const filterSelector = document.querySelector('.select');

        if (sortBySelector && filterSelector) {
          // Get the computed height of filterSelector
          const stickyFiltersHeight = window.getComputedStyle(filterSelector).getPropertyValue('height');
          //alert(stickyFiltersHeight);

          // Set the height of sortBySelector to match filterSelector
            sortBySelector.style.height = stickyFiltersHeight;
        }
      }
    }

    hide() {
      this.closeSearchModal();
    }

    reveal() {
      document.body.classList.add('stickyheader--active');
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('stickyheader--active');
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader); 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({note: event.target.value});
        fetch(`${
          routes.cart_update_url
        }`, {
          ...fetchConfig(),
          ...{
            body
          }
        });
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
 class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = async (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      console.log('ProductRecommendations: IntersectionObserver triggered');
      observer.unobserve(this);
      console.log('AAA', this.dataset.url);

      try {
        const response = await fetch(this.dataset.url);
        const text = await response.text();
        const html = document.createElement('div');
        html.innerHTML = text;

        const recommendations = html.querySelector('.product-recommendations-section');
        if (recommendations && recommendations.innerHTML.trim().length) {
          if (this.classList.contains('cart-recommendations')) return;
          console.log("I am called", recommendations);
          this.innerHTML = recommendations.innerHTML;
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      } catch (e) {
        console.error(e);
      }
    };

    // Bind handleIntersection to `this` so it maintains the correct context
    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();
})();
